import { Button, Dropdown, MenuProps } from 'antd'
import { useTranslation } from 'react-i18next'
import i18n from '../i18n'

type Props = {}

export default function LanguageSwitch({}: Props) {
    const { t } = useTranslation()

    function handleLanguageChange(locale: string) {
        i18n.changeLanguage(locale)
    }

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: <div onClick={() => handleLanguageChange('en')}>{t('English', { ns: 'common' })}</div>
        },
        {
            key: '2',
            label: <div onClick={() => handleLanguageChange('vi')}>{t('Vietnamese', { ns: 'common' })}</div>
        }
    ]

    return (
        <div>
            <Dropdown menu={{ items }}>
                <Button>{i18n.language}</Button>
            </Dropdown>
        </div>
    )
}
